export const ADD_EMPLOYMENT_REQUEST = 'ADD_EMPLOYMENT_REQUEST';
export const ADD_EMPLOYMENT_SUCCESS = 'ADD_EMPLOYMENT_SUCCESS';
export const ADD_EMPLOYMENT_FAILURE = 'ADD_EMPLOYMENT_FAILURE';

export const REMOVE_EMPLOYMENT_REQUEST = 'REMOVE_EMPLOYMENT_REQUEST';
export const REMOVE_EMPLOYMENT_SUCCESS = 'REMOVE_EMPLOYMENT_SUCCESS';
export const REMOVE_EMPLOYMENT_FAILURE = 'REMOVE_EMPLOYMENT_FAILURE';

export const GET_EMPLOYMENTS_REQUEST = 'GET_EMPLOYMENTS_REQUEST';
export const GET_EMPLOYMENTS_SUCCESS = 'GET_EMPLOYMENTS_SUCCESS';
export const GET_EMPLOYMENTS_FAILURE = 'GET_EMPLOYMENTS_FAILURE';

export const CONFIRM_EMPLOYMENT_REQUEST = 'CONFIRM_EMPLOYMENT_REQUEST';
export const CONFIRM_EMPLOYMENT_SUCCESS = 'CONFIRM_EMPLOYMENT_SUCCESS';
export const CONFIRM_EMPLOYMENT_FAILURE = 'CONFIRM_EMPLOYMENT_FAILURE';

export const UPDATE_EMPLOYMENTS_REQUEST = 'UPDATE_EMPLOYMENTS_REQUEST';
export const UPDATE_EMPLOYMENTS_SUCCESS = 'UPDATE_EMPLOYMENTS_SUCCESS';
export const UPDATE_EMPLOYMENTS_FAILURE = 'UPDATE_EMPLOYMENTS_FAILURE';

export const UPDATE_EMPLOYMENTUNITS_REQUEST = 'UPDATE_EMPLOYMENTUNITS_REQUEST';
export const UPDATE_EMPLOYMENTUNITS_SUCCESS = 'UPDATE_EMPLOYMENTUNITS_SUCCESS';
export const UPDATE_EMPLOYMENTUNITS_FAILURE = 'UPDATE_EMPLOYMENTUNITS_FAILURE';